import styled from "styled-components";
import CustomLabel from "../../applicationUI/CustomLabel";
import LoggedInBoilerplate from "./LoggedInBoilerplate";

import goTo from "../../../controllers/goTo";
import contentPurposeTypes from "../../../data/contentPurposeTypes";
import { useContext } from "react";
import Context from "../../../Context";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 50px;
  width: 300px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const TypeButton = styled.div`
  background-color: transparent;
  border: 1px solid var(--accent);

  color: var(--accent);
  border-radius: 10px;
  padding: 18px 20px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: var(--accentSurface);
    border: 1px solid var(--accent);
  }
`;

export default function SelectContentType() {
  const { loggedInUser } = useContext(Context);

  return (
    <LoggedInBoilerplate
      titleLine1={"Select"}
      titleLine2={"Post Type"}
      showBackButton={true}
    >
      <Container>
        <List>
          {contentPurposeTypes.map((item) => {
            if (
              loggedInUser.accountType == "INDIVIDUAL" &&
              item.value == "FUNDS_NEEDED"
            )
              return null;

            return (
              <TypeButton
                onClick={goTo(`/manage-post/?defaultPurpose=${item.value}`)}
              >
                {item.label}
              </TypeButton>
            );
          })}
        </List>
      </Container>
    </LoggedInBoilerplate>
  );
}
